import ServiceHandler from '../../../../services/service-handler';
import { XML_VIN_MISMATCH_MSG } from '../../../../support/support-constants';
import React from 'react';

interface Props {
    logFileError: string | undefined;
    xmlVinMismatchMessage: string | undefined;
    pendingLogFileErrorMessage: string | undefined;
    event: any;
    vin: string;
    setLogFileResponseLoading: React.Dispatch<React.SetStateAction<boolean>>;
    setLogFileErrorMessage: React.Dispatch<React.SetStateAction<string>>;
    setPendingLogFileErrorMessage: React.Dispatch<React.SetStateAction<string>>;
    setXmlVinMismatchMessage: React.Dispatch<React.SetStateAction<string>>;
    localStorageWrapper: any;
    setLogFiles: any;
}

export const SyncInstallUpdatesAddFiles = async (props: Props) => {
    props.setLogFiles(props.event?.target?.files);
    const uploadResponse = await ServiceHandler.SyncMapService.uploadLogFiles(
        props.event.target.files[0],
        props.vin
    );
    if (uploadResponse.errorDetails?.includes(XML_VIN_MISMATCH_MSG)) {
        props.setXmlVinMismatchMessage(props?.xmlVinMismatchMessage || '');
    } else {
        if (props.pendingLogFileErrorMessage) {
            props.setPendingLogFileErrorMessage(
                props?.pendingLogFileErrorMessage || ''
            );
        } else {
            props.setLogFileErrorMessage(props.logFileError || '');
        }
    }
};
